import { render, staticRenderFns } from "./lookGood.vue?vue&type=template&id=d5a6a2f0&"
import script from "./lookGood.vue?vue&type=script&lang=js&"
export * from "./lookGood.vue?vue&type=script&lang=js&"
import style0 from "./lookGood.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports